import firestore from "../../../firebase/firestore";
let couponRef = firestore.collection("coupons");
export default {
  resetFilter({ commit }) {
    commit("resetState");
  },
  async getCoupons({ commit }, params) {
    try {
      commit("setLoading", true);
      // commit('setCoupons', [])
      if (params) {
        if (params.status) {
          couponRef = couponRef.where("status", "==", params.status);
        }
      }
      let couponsList = [];
      return couponRef.orderBy("created_at", "desc").onSnapshot(async (res) => {
        const changes = res.docChanges();
        await changes.forEach((change) => {
          const { doc } = change;
          // console.log('change.type: ', change.type)
          switch (change.type) {
            case "added": {
              const data = {
                id: doc.id,
                ...doc.data(),
              };
              couponsList.push(data);
              break;
            }
            case "modified": {
              const data = {
                id: doc.id,
                ...doc.data(),
              };
              // eslint-disable-next-line no-shadow
              const i = couponsList.findIndex((i) => i.id === doc.id);
              couponsList.splice(i, 1, data);
              // couponsList[i] = data
              // console.log('modified after splice2', invoices)
              break;
            }
            case "removed": {
              couponsList = couponsList.filter((i) => i.id !== doc.id);
              break;
            }
            default:
              break;
          }
        });
        await commit("setCoupons", couponsList);
        await commit("setLoading", false);
        return couponsList;
      });
    } catch (err) {
      commit("setCoupons", []);
      await commit("setLoading", false);
      console.error(err);
    }
  },
  createCoupon({ commit }, data) {
    return new Promise((resolve, reject) => {
      couponRef
        .add(data)
        .then((doc) => {
          let coupon_data = {
            id: doc.id,
            ...data,
          };
          commit("setCoupon", coupon_data);
          resolve(true);
        })
        .catch((err) => {
          console.error(err);
          reject(err);
        });
    });
  },
};
